export const locale = {
    'EQUIPMENT': {
        'NONE': 'Нет',
        'AVAILABLE': 'Есть',
        'UNAVAILABLE': 'Нет',

        'compressor': 'Компрессор',
    },
}
